const REFERRAL_STORAGE_KEY = 'referralCode';
const DEFAULT_PARTNER_INVITE_BASE_URL =
  process.env.REACT_APP_PARTNER_INVITE_BASE_URL ||
  process.env.PARTNER_INVITE_BASE_URL ||
  'https://hedger.bar/invite';

export const normalizeReferralCode = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const getStoredReferralCode = () => {
  if (typeof window === 'undefined') return '';
  return normalizeReferralCode(localStorage.getItem(REFERRAL_STORAGE_KEY));
};

export const storeReferralCode = (code) => {
  if (typeof window === 'undefined') return;
  const normalized = normalizeReferralCode(code);
  if (!normalized) {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
    return;
  }
  localStorage.setItem(REFERRAL_STORAGE_KEY, normalized);
};

export const clearStoredReferralCode = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
};

export const buildReferralLink = (code, baseUrl) => {
  const normalized = normalizeReferralCode(code);
  if (!normalized) return '';
  const base = normalizeReferralCode(baseUrl) || DEFAULT_PARTNER_INVITE_BASE_URL;
  const trimmed = base.replace(/\/+$/, '');
  return `${trimmed}/${encodeURIComponent(normalized)}`;
};

export const readReferralFromSearch = (search) => {
  if (!search) return '';
  const params = new URLSearchParams(search);
  return (
    params.get('ref') ||
    params.get('referral') ||
    params.get('invite') ||
    ''
  );
};

export const generateReferralCode = () => {
  const randomPart = Math.random().toString(36).slice(2, 8);
  return `tp-${randomPart}`.toLowerCase();
};
